var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.orientationCustomize,
    _vm.hasGrid ? _vm.gridCustomize : [_vm.xlGrid, _vm.lgGrid, _vm.mdGrid, _vm.smGrid],
  ]},[(_vm.title)?_c('ontick-card-title',{staticClass:"block px-3 pb-6"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{class:[
      !_vm.noBackground ? 'bg-gray-50 shadow dark:bg-ontick-graphite-500' : '',
      'w-full rounded-lg border border-ontick-steel-300 dark:border-ontick-graphite-500',
      _vm.paddingCustomize,
    ],style:(_vm.borderCustomize)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }